import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import landingPageImage from '../assets/images/landingpage-image.png';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import mapforce from '../assets/images/altova/logos/mapforce.svg';
import missionkit from '../assets/images/altova/logos/missionkit.svg';
import xmlspy from '../assets/images/altova/logos/xmlspy.svg';
import stylevision from '../assets/images/altova/logos/stylevision.svg';
import umodel from '../assets/images/altova/logos/umodel.svg';
import mobiletogether from '../assets/images/altova/logos/mobiletogether.svg';
import flowforceserver from '../assets/images/altova/logos/flowforce_server.svg';
import databasespy from '../assets/images/altova/logos/databasespy.svg';
import altovaTrainingPartner from '../assets/images/altova/logos/altovaPartner.gif';
import altovaConsultPartner from '../assets/images/altova/logos/altovaPartnerConsult.gif';


const TrainingPopup = ({ isVisible, onClose, children, categoriesProp, closeNavbarOnClick }) => {
  const navigate = useNavigate();
  const categories = categoriesProp.sort((a, b) => a.localeCompare(b)); // Sort alphabetically


  const [isPopupVisible, setPopupVisible] = useState(false); // State for popup visibility
  const togglePopup = () => {
    setPopupVisible(!isPopupVisible); // Toggle popup visibility
  };

  // Handles both closing the popup and collapsing the navbar
  const handleClose = () => {
    if (onClose) onClose();
    if (closeNavbarOnClick) closeNavbarOnClick();
  };

  const hidePopup = () => {
    setPopupVisible(false); // Hide popup
    if (closeNavbarOnClick) closeNavbarOnClick();
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const handleOutsideClick = (event) => {
    if (event.target.classList.contains("popup-overlay")) {
      onClose();
    }
  };

  return (

    <>
      <div className="popup-overlay" onClick={handleOutsideClick} >
        <div className="popup-box" >
          <button className="close-button" onClick={onClose}>&times;</button>
          <div className="popup-section">
            <h1 className="green-gradient-font">Course Categories</h1>            <ul className="categories-list">
              {categories.map((category, index) => (
                <li key={category}>
                  <Link
                    to={`/categories/${category}`}
                    onClick={handleClose}
                  >
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
            <button className="btn btn-dark  border rounded-pill px-3 ms-lg-3" onClick={() => {
              navigate('/training');
              handleClose();
            }}>
              View Courses
            </button>
          </div>
          <div className="popup-section">
            <h1 className="green-gradient-font">Training for Teams</h1>
            <p>Exceptional training for your team.</p>
            <p>Any of our training programs can be tailored ready for delivery for your team.</p>
            <p>We recognise that in a busy organisation, blocking people out for extended periods of training can be disruptive,
              hence our delivery mechanisms are designed to work around you. Training can be in person, virtual in person, and spread over multiple days.</p>            <p>              <button className="btn btn-dark  border rounded-pill px-3 ms-lg-3" onClick={() => {
                navigate('/training');
                handleClose();
              }}>
                Explore training for Teams
              </button>
              <button className="btn btn-light  border rounded-pill px-3 ms-lg-3" onClick={() => {
                navigate('/contact');
                handleClose();
              }}>
                Get in touch Today
              </button>

            </p>
          </div>
          <div className="popup-section">
            <h1 className="green-gradient-font">Altova</h1>
            <p>Our team have been working with Altova for over 20 years, providing comprehensive training and consulting on the product suite.
              Most of our consulting is on Mapforce and Stylevision, which seem to be the products that cause our customers the most challenge.
            </p>            <p>              <button className="btn btn-dark  border rounded-pill px-3 ms-lg-3" onClick={() => {
                navigate('/altova');
                handleClose();
              }}>
                Find out More
              </button>
            </p>
            <div className="icon-grid">
              <img src={missionkit} alt="MissionKit" />
              <img src={xmlspy} alt="XMLSpy" />
              <img src={mapforce} alt="MapForce" />
              <img src={stylevision} alt="StyleVision" />
              <img src={umodel} alt="UModel" />
              <img src={mobiletogether} alt="MobileTogether" />
              <img src={flowforceserver} alt="Flowforce Server" />
              <img src={databasespy} alt="DatabaseSpy" />
            </div>
          </div>
        </div>
      </div>
    </>

  );
}
export default TrainingPopup;